module.exports = {
  "dof-search-bar": {
    "paddingLeft": "32",
    "paddingRight": "32",
    "backgroundColor": "#ffffff",
    "height": "88",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "dof-search-bar-gray": {
    "backgroundColor": "#f6f7f9"
  },
  "dof-search-bar-black": {
    "backgroundColor": "#1e2e37"
  },
  "search-bar-input": {
    "position": "absolute",
    "top": "8",
    "paddingTop": 0,
    "paddingBottom": 0,
    "paddingRight": "40",
    "paddingLeft": "60",
    "fontSize": "28",
    "width": "624",
    "height": "72",
    "lineHeight": "72",
    "backgroundColor": "#f6f7f9",
    "borderRadius": "36",
    "color": "#1e2e37",
    "placeholderColor": "#8e969b"
  },
  "search-bar-input-gray": {
    "backgroundColor": "#ffffff",
    "color": "#1e2e37",
    "placeholderColor": "#8e969b"
  },
  "search-bar-input-black": {
    "backgroundColor": "rgba(249,249,249,0.2)",
    "color": "#1e2e37",
    "placeholderColor": "#c7c7cc"
  },
  "search-bar-arrow": {
    "position": "absolute",
    "width": "36",
    "height": "36",
    "left": "32",
    "top": "28"
  },
  "search-bar-arrow-base": {
    "position": "absolute",
    "width": "48",
    "height": "48",
    "left": "26",
    "top": "22"
  },
  "search-bar-icon": {
    "position": "absolute",
    "width": "32",
    "height": "32",
    "left": "48",
    "top": "28"
  },
  "search-bar-icon-hasArrow": {
    "left": "120"
  },
  "search-bar-close": {
    "position": "absolute",
    "width": "34",
    "height": "32",
    "right": "48",
    "top": "28"
  },
  "right-content": {
    "position": "absolute",
    "right": "8"
  },
  "search-bar-button": {
    "width": "72",
    "fontSize": "32",
    "textAlign": "center",
    "lineHeight": "88",
    "marginRight": 0,
    "color": "#616c73",
    "position": "absolute",
    "right": "32"
  },
  "search-bar-button-gray": {
    "backgroundColor": "#f6f7f9"
  },
  "search-bar-button-black": {
    "backgroundColor": "#1e2e37",
    "color": "#c7c7cc"
  },
  "bar-dep": {
    "position": "absolute",
    "flexDirection": "row",
    "alignItems": "center",
    "width": "130",
    "paddingRight": "12",
    "paddingLeft": "12",
    "height": "42",
    "right": "144",
    "top": "22"
  },
  "bar-dep-black": {
    "borderRightColor": "#c7c7c7"
  },
  "selected-text": {
    "flex": 1,
    "lineHeight": "32",
    "textAlign": "center",
    "fontSize": "24",
    "color": "#1e2e37",
    "marginRight": "6",
    "marginTop": "2",
    "lines": 1,
    "textOverflow": "ellipsis"
  },
  "selected-text-black": {
    "color": "#c7c7cc"
  },
  "select-text": {
    "flex": 1,
    "lineHeight": "40",
    "textAlign": "center",
    "fontSize": "24",
    "color": "#1e2e37",
    "marginRight": "2",
    "lines": 1,
    "textOverflow": "ellipsis"
  },
  "select-text-black": {
    "color": "#c7c7cc"
  },
  "dep-arrow": {
    "width": "24",
    "height": "24"
  },
  "disabled-input": {
    "height": "72",
    "position": "absolute",
    "left": 0,
    "backgroundColor": "rgba(255,255,255,0.7)"
  },
  "has-dep-disabled": {
    "width": "640"
  },
  "selectBlock": {
    "position": "fixed",
    "width": "132",
    "top": 0,
    "marginLeft": "-28",
    "paddingBottom": "10",
    "borderRadius": "4",
    "backgroundColor": "#f6f6f6"
  },
  "selectBlock-gray": {
    "backgroundColor": "#ffffff"
  },
  "selectBlock-black": {
    "backgroundColor": "#323232"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-1dc60808!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-searchbar/index.vue
// module id = 432
// module chunks = 0 1